module.exports = __webpack_public_path__ + "housingStatic/img/moudle_name_item4.ececf16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource_center/moudle_name_item4.png
// module id = C5Jc
// module chunks = 2